import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'
import type * as models from '../models'

const QUERY: ents.core.dms.data.query.Query<models.Outcome> = {
  selection: {
    '{}': {
      description: { '@.': '!descr' },
      entityId: { '@_': 'id' },
      id: { '@.': '!id' },
      name: { '@.': '!name' },
      parentId: { '@^': 'parent' },
    },
  },
  target: 'dim::!outcomes',
}

const isZoneContextDefined = <T, U>(
  data: [T, U],
): data is [T, NonNullable<U>] => !!data[1]

// TODO: Implement
export const onOutcomesRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.getOutcomes.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.filter(isZoneContextDefined),
      rxjs.switchMap(([action, zoneContext]) =>
        gql.queries.outcomes
          .execute({
            ...zoneContext,
            query: JSON.stringify(QUERY),
          })
          .pipe(
            // Handles success
            rxjs.map(outcomes =>
              feature.actions.getOutcomes.success.from(action).create({
                request: action.data,
                response: outcomes,
              }),
            ),
            // Handles error
            rxjs.catchError(error =>
              rxjs.of(
                feature.actions.getOutcomes.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          ),
      ),
    ),
)
